import { getContext, setContext } from 'svelte';
import type { Readable } from 'svelte/store';
import { readable } from 'svelte/store';

const symbol = Symbol('context of Current ZIndex');

export function getCurrentZIndexContext() {
    return getContext<Readable<number>>(symbol) ?? readable(1);
}

export function getCurrentZIndex(): Readable<number> {
    return getCurrentZIndexContext();
}

export function setCurrentZIndexContext(zIndex: Readable<number>): void {
    setContext<Readable<number>>(symbol, zIndex);
}
